import { render } from "./IntegratedDeviceBox.vue?vue&type=template&id=630e01f7&scoped=true"
import script from "./IntegratedDeviceBox.vue?vue&type=script&lang=js"
export * from "./IntegratedDeviceBox.vue?vue&type=script&lang=js"

import "./IntegratedDeviceBox.vue?vue&type=style&index=0&id=630e01f7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630e01f7"]])

export default __exports__